import { definePermission } from "./permission";
/**
 * Account administration (`D52`): listing every account, and banning one.
 *
 * `account:read:all` carries the breadth in a SUFFIX, not in a mode. Reading
 * your own account needs no permission at all — the token already says who you
 * are — so there is no `account:read` here. `resource_mode` stays a
 * token-level lock meaning "a human acting for themselves" and never means
 * cross-account: mixing the two would make removing a power require reissuing
 * a token.
 */
export const ACCOUNT_READ_ALL = definePermission("account:read:all", "List and read every account on the platform.");
/** Ban is a pure flag (`D63`) — set and unset, nothing timed. */
export const ACCOUNT_BAN = definePermission("account:ban", "Ban or unban an account.");
export const ACCOUNT_PERMISSIONS = [ACCOUNT_READ_ALL, ACCOUNT_BAN];
//# sourceMappingURL=accounts.js.map